import { render, staticRenderFns } from "./ItemVariacao.vue?vue&type=template&id=67366374&scoped=true&lang=pug"
import script from "./ItemVariacao.vue?vue&type=script&lang=js"
export * from "./ItemVariacao.vue?vue&type=script&lang=js"
import style0 from "./ItemVariacao.vue?vue&type=style&index=0&id=67366374&prod&lang=scss"
import style1 from "./ItemVariacao.vue?vue&type=style&index=1&id=67366374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67366374",
  null
  
)

export default component.exports